import "./App.css";
import React from "react";
import Home from "./pages/Home";
import Master from "./pages/Master";
import Login from "./pages/Login";
import Notfound from "./pages/NotFound";
import Settings from "./pages/Settings";
import Rates from "./pages/Rates/Rates";
import Abstract from "./pages/Abstract/Abstract";
import UserHistory from "./components/UserHistory/UserHistory";
import {BrowserRouter as Router, Routes, Route} from "react-router-dom";
import {ToastContainer} from "react-toastify";
import {ProtectedRoute} from "./ProtectedRoute";
import AttendancePage from "./pages/AttendancePage";
import Vehicle from "./components/vehicle/Vehicle";

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<AttendancePage />} />
            <Route path="/attendance" element={<AttendancePage />} />
            <Route path="/master" element={<Master />} />
            <Route path="/vehicles" element={<Vehicle />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/rates" element={<Rates />} />
            <Route path="/abstract" element={<Abstract />} />
            <Route path="/user-history" element={<UserHistory />} />
          </Route>

          <Route path="/*" element={<Notfound />} />
        </Routes>
      </Router>
      <ToastContainer />
    </div>
  );
}

export default App;
